export const Radio = ({ checked, onChange, text }) => {
  return (
    <section className="radio-main">
      <label className="radio-label">
        <p className="radio-text">{text}</p>
        <input
          type="radio"
          value={text}
          checked={checked}
          onChange={e => onChange(e.target.value)}
        />
        <span className="radio-box"></span>
      </label>
    </section>
  );
};
